import { useQuotingEmployeeContext } from 'components/quoting/employees/QuotingEmployeeContext'
import { useQuotePricing } from 'components/quoting/quotes/pricing/QuotePricingProvider'
import {
  Tabs,
  TabsContent,
  TabsContents,
  TabsList,
  TabsTrigger,
} from 'components/ui/animate-ui/tabs'

import CostBreakdown from './CostBreakdown'

type TotalCostBreakdownCardProps = {
  isLoading?: boolean,
  currentPlanTotalEmployerMedicalContribution: number,
  currentPlanTotalEmployeeMedicalContribution: number,
  totalMonthlyEmployerCost: number,
  totalMonthlyEmployeeContribution: number,
  shouldDisplayComparisons?: boolean
}

export const TotalCostBreakdownCard = ({
  isLoading,
  currentPlanTotalEmployerMedicalContribution,
  currentPlanTotalEmployeeMedicalContribution,
  totalMonthlyEmployerCost,
  totalMonthlyEmployeeContribution,
  shouldDisplayComparisons,
}: TotalCostBreakdownCardProps) => {
  const { willEnrollEmployeeIds } = useQuotingEmployeeContext()

  const { getTotalCost } = useQuotePricing()

  const totalMonthlyFees = getTotalCost(willEnrollEmployeeIds.size)

  return (
    <div
      className='bg-white rounded-2xl border shadow-md'
      data-testid='total-cost-breakdown-card'
    >
      <Tabs defaultValue='monthly' className='bg-muted rounded-lg'>
        <TabsList className='grid w-full grid-cols-2 overflow-hidden p-2'>
          <TabsTrigger className='rounded-l-lg aria-selected:bg-thatch-200 aria-selected:border-thatch-500 border border-gray-200' value='monthly'>Monthly</TabsTrigger>
          <TabsTrigger className='rounded-r-lg aria-selected:bg-thatch-200 aria-selected:border-thatch-500 border border-gray-200' value='annual'>Annual</TabsTrigger>
        </TabsList>

        <TabsContents className='h-full bg-background'>
          <TabsContent value='monthly' className='p-4'>
            {isLoading
              ? <div className='w-full h-56 bg-gray-200 animate-pulse rounded-md mt-4' />
              : (
                <CostBreakdown
                  employeePerPeriodCost={totalMonthlyEmployeeContribution}
                  employeePreviousPerPeriodCost={currentPlanTotalEmployeeMedicalContribution}
                  employerPerPeriodCost={totalMonthlyEmployerCost}
                  employerPreviousPerPeriodCost={currentPlanTotalEmployerMedicalContribution}
                  additionalPerPeriodCost={totalMonthlyFees}
                  period='monthly'
                  shouldDisplayComparisons={shouldDisplayComparisons}
                />
                )}
          </TabsContent>
          <TabsContent value='annual' className='p-4'>
            {isLoading
              ? <div className='w-full h-56 bg-gray-200 animate-pulse rounded-md mt-4' />
              : (
                <CostBreakdown
                  employeePerPeriodCost={totalMonthlyEmployeeContribution * 12}
                  employeePreviousPerPeriodCost={currentPlanTotalEmployeeMedicalContribution * 12}
                  employerPerPeriodCost={totalMonthlyEmployerCost * 12}
                  employerPreviousPerPeriodCost={currentPlanTotalEmployerMedicalContribution * 12}
                  additionalPerPeriodCost={totalMonthlyFees * 12}
                  period='annual'
                  shouldDisplayComparisons={shouldDisplayComparisons}
                />
                )}
          </TabsContent>
        </TabsContents>
      </Tabs>
    </div>
  )
}
